import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Box,
  AppBar,
  Toolbar,
  Container,
  Button } from '@mui/material';

import { OutlinedButton } from '../buttons/outlined-button';
import { useCustomParam } from '../../hooks/use-custom-param';
import { RecordContext } from '../record-context';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebaseConfig/firebase.config';
import { PDFDownloadLink } from "@react-pdf/renderer";

import logo from '../../images/logo.svg';
import pdfIcon from '../../images/icons/pdf.svg';
import shareIcon from '../../images/icons/share.svg';
import pdfGrayIcon from '../../images/icons/pdf-gray.svg';
import shareGrayIcon from '../../images/icons/share-gray.svg';
import saveIcon from '../../images/icons/save.svg';
import PDFFile from '../../pdf/PDFFile'
import { updateAction } from '../action/updateAction';
import useAnalytics from "../../segment/useAnalytics";
import { useNotify } from '../../hooks/use-notify';

export const Header = () => {
  const isEdit = false;
  const { id } = useParams();
  const { record, recordDispatch } = useContext(RecordContext);
  const [notify] = useNotify();
  const { captureEdited, captureExported } = useAnalytics();

  const handleShare = () => {
    const actualWidth = document.body.clientHeight || document.body.offsetHeight;
    console.log(actualWidth);
    window.open(`${record.userDashboard}?open_trainual_capture_modal=true&id=${id}&height=${actualWidth}`);
    captureExported({ destination: 'Trainual' });
  }

  const setIsSaving = (isSaving) => {
    recordDispatch(
      updateAction({
        ...record,
        saving: isSaving,
      })
    );
  }

  const handleSave = async (id) => {
    (async () => {
      setIsSaving(true);
      await setDoc(doc(db, 'records', id), { ...record });
      recordDispatch(
        updateAction({
          ...record,
          needSave: false,
        })
      );
    })()
      .then(() => {
        setIsSaving(false);
        // setShowSaveNotification(true);
        notify('Changes success saved!');
        captureEdited();
      })
      .catch(() => {
        notify('Something went wrong', 'error');
        setIsSaving(false);
      });
  };

  return (
    <AppBar component="nav">
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between'}}>
          <img src={logo} alt='logo'/>
          <Box>
            { isEdit && record.arr.length ?
              <Box display='flex'>
                {(isEdit) &&
                  <Box mr={1}>
                    {
                      record.needSave ?
                        <OutlinedButton title='Export PDF' icon={pdfGrayIcon} disabled={true} /> :
                        <PDFDownloadLink document={<PDFFile data={record} />} fileName="trainual-capture" style={ {textDecoration: "none"} }>
                          {({loading}) => (loading || !record.isLoaded ? <OutlinedButton title='Loading...' icon={record.needSave ? pdfGrayIcon: pdfIcon} disabled={record.needSave} /> : <OutlinedButton title='Export PDF' icon={record.needSave ? pdfGrayIcon: pdfIcon} disabled={record.needSave} />)}
                        </PDFDownloadLink>
                    }
                  </Box>
                }
                {record.needSave ?
                  <Button variant='contained' onClick={() => handleSave(id)}>
                    {record.saving ? 'Autosaving...' : 'Save changes'}
                  </Button>
                  :
                  <Button variant="contained" startIcon={<img src={saveIcon} alt='icon'/>}>
                    Saved
                  </Button>
                }
              </Box>
              :
              <Box>
                <Box mr={1}>
                  <PDFDownloadLink document={<PDFFile data={record} />} fileName="trainual-capture" style={ {textDecoration: "none"} }>
                    {({loading}) => (loading || !record.isLoaded ? <OutlinedButton title='Loading...' icon={pdfIcon} /> : <OutlinedButton title='Export PDF' icon={pdfIcon} onClick={() => captureExported({ destination: 'pdf' })}/>)}
                  </PDFDownloadLink>
                </Box>
              </Box>
            }
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
